module.exports = __webpack_public_path__ + "img/40446579.4c2b7a52.png";